module.exports = __webpack_public_path__ + "static/media/user.ded7b879.svg";